import React, {useEffect} from "react";
import {useLocation} from "react-router-dom";
import ForgotPasswordForm from "../features/auth/components/forgot-password-form";
import ResetPasswordForm from "../features/auth/components/reset-password-form";

const ForgotPasswordPage = () => {
    const location = useLocation();

    const tokenFromUrl = new URLSearchParams(location.search).get("token");

    useEffect(() => {
        if (tokenFromUrl) {
            const url = new URL(window.location as any);
            url.searchParams.delete("token");
            window.history.replaceState({}, '', url.toString());
        }
    }, [tokenFromUrl, location]);

    if (tokenFromUrl) {
        return (
            <div className="min-h-screen bg-[#DFE6E7] flex items-center justify-center p-4">
                <div className="max-w-md w-full">
                    <div className="flex flex-col gap-12 bg-white rounded-[2rem] shadow-sm p-8 border border-gray-200">
                        <span className="font-semibold text-2xl">Resetuj hasło</span>
                        <ResetPasswordForm token={tokenFromUrl}/>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#DFE6E7] flex items-center justify-center p-4">
            <div className="max-w-md w-full">
                <div className="flex flex-col gap-12 bg-white rounded-[2rem] shadow-sm p-8 border border-gray-200">
                    <span className="font-semibold text-2xl">Zapomniałeś hasła?</span>
                    <span className="text-lg font-semibold">Wpisz swój email aby zresetować hasło.</span>
                    <ForgotPasswordForm/>
                </div>
            </div>
        </div>
    );
}

export default ForgotPasswordPage
